import { render } from "./TaskConfigView.vue?vue&type=template&id=38539a4c"
import script from "./TaskConfigView.vue?vue&type=script&lang=js"
export * from "./TaskConfigView.vue?vue&type=script&lang=js"

import "./TaskConfigView.vue?vue&type=style&index=0&id=38539a4c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__